export default "__VITE_ASSET__moT5E2V7__"